export enum CalendarEventsFilters {
    All = 'All',
    Appointments = 'Appointments',
    Organizer = 'Organizer',
    Attendee = 'Attendee',
    Accepted = 'Accepted',
}
